module.exports = require("!!vue-loader!../../../node_modules/vue-markdown-loader/lib/markdown-compiler.js?raw!./privacy.md");


//////////////////
// WEBPACK FOOTER
// ./client/models/content/privacy.md
// module id = 437
// module chunks = 0